var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000, -2.000000)","fill":"#4F4F4F"},React.createElement("path",{"d":"M11.1432192,14.8280379 C4.53607427,14.8280379 0.509179922,9.44249456 0.509179922,8.90260931 C0.509179922,8.36272407 4.53607427,2.97718069 11.1432192,2.97718069 C17.7503642,2.97718069 21.7772585,8.66304608 21.7772585,8.90260931 C21.7772585,9.14217254 17.7503642,14.8280379 11.1432192,14.8280379 Z M11.1432192,13.6741387 C13.918157,13.6741387 16.1803957,11.5452104 16.1803957,8.90260931 C16.1803957,6.26000818 13.918157,4.13107995 11.1432192,4.13107995 C8.36828145,4.13107995 6.10604271,6.26000818 6.10604271,8.90260931 C6.10604271,11.5452104 8.36828145,13.6741387 11.1432192,13.6741387 Z M11.1432192,12.42668 C9.04973441,12.42668 7.36533684,10.8415416 7.36533684,8.90260931 C7.36533684,6.96367703 9.04973441,5.3785386 11.1432192,5.3785386 C13.236704,5.3785386 14.9211016,6.96367703 14.9211016,8.90260931 C14.9211016,10.8415416 13.236704,12.42668 11.1432192,12.42668 Z","id":"Combined-Shape"})));
}

Eye.defaultProps = {"width":"22px","height":"13px","viewBox":"0 0 22 13","version":"1.1"};

module.exports = Eye;

Eye.default = Eye;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/eye.svg
// module id = 1483
// module chunks = 0